





























import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.land.latestUseDesignation",
            inputName: "latest-land-designation",
            specificId: uuidv4() as string
        };
    },
    computed: {
        landDesignation: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "LAND"].indexOf(this.getPropertyType()) !== - 1;
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("farming_area"),
                    "value": "FARMING_AREA"
                },
                {
                    "label": this.$t("another_type_of_area"),
                    "value": "OTHER"
                },
                {
                    "label": this.$t("economic_activity_area"),
                    "value": "ECONOMIC_ACTIVITY_AREA"
                },
                {
                    "label": this.$t("extraction_area"),
                    "value": "EXTRACTION_AREA"
                },
                {
                    "label": this.$t("reserved_area"),
                    "value": "LAND_RESERVE_AREA"
                },
                {
                    "label": this.$t("forest_area"),
                    "value": "FOREST_AREA"
                },
                {
                    "label": this.$t("residential_recreation_area_GVR"),
                    "value": "DAYTIME_RECREATION_AREA"
                },
                {
                    "label": this.$t("residential_recreation_area_GDR"),
                    "value": "RESIDENTIAL_RECREATION_AREA"
                },
                {
                    "label": this.$t("industrial_commercial_area"),
                    "value": "INDUSTRIAL_ZONE_FOR_CRAFT_OR_SMALL_AND_MEDIUM_ENTERPRISES"
                },
                {
                    "label": this.$t("industrial_area"),
                    "value": "INDUSTRIAL_AREA"
                },
                {
                    "label": this.$t("leisure_area"),
                    "value": "LEISURE_AREA"
                },
                {
                    "label": this.$t("area_of_landscape_interest"),
                    "value": "AREA_OF_LANDSCAPE_INTEREST"
                },
                {
                    "label": this.$t("mixed_living_area"),
                    "value": "MIXED_LIVING_AREA"
                },
                {
                    "label": this.$t("natural_area"),
                    "value": "NATURAL_AREA"
                },
                {
                    "label": this.$t("nature_reserve"),
                    "value": "NATURE_RESERVE"
                },
                {
                    "label": this.$t("park_area"),
                    "value": "PARK_AREA"
                },
                {
                    "label": this.$t("residential"),
                    "value": "LIVING_AREA"
                },
                {
                    "label": this.$t("green_area"),
                    "value": "GREEN_AREA"
                },
                {
                    "label": this.$t("residential_area_with_cultural_historical_esthetic_value"),
                    "value": "RESIDENTIAL_AREA_WITH_CULTURAL_HISTORICAL_AND_ESTHETIC_VALUE"
                },
                {
                    "label": this.$t("residential_park"),
                    "value": "RESIDENTIAL_PARK"
                },
                {
                    "label": this.$t("extended_residential_area"),
                    "value": "RESIDENTIAL_EXPANSION_AREA"
                }
            ];
        }
    },
    mounted: function() {
        if (this.isDisplayed) {
            if(this.$store.getters["FormModule/getValue"](this.pathInStore) == null) {
                // this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: ""});
            }
        } else {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(landDesignationValue: string): void {
            if (landDesignationValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": landDesignationValue});
            }
        }
    },
});
